module.exports = __webpack_public_path__ + "img/keyboard-arrow-return-1.083f74c7.svg";